/**
 * @deprecated Use `useLocation` from `react-router-dom` instead.
 */
export const getCurrentLocation = (
  searchParamsToAppend?: URLSearchParams,
): string => {
  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname;
  const basename = __BASENAME__ ? `/${__BASENAME__}` : undefined;
  const pathnameWithoutBasename =
    basename && pathname.startsWith(basename)
      ? pathname.slice(basename.length)
      : pathname;
  currentUrl.pathname = pathnameWithoutBasename;

  if (searchParamsToAppend) {
    for (const [key, value] of searchParamsToAppend.entries()) {
      currentUrl.searchParams.set(key, value);
    }
  }

  return `${currentUrl.origin}${currentUrl.href.slice(currentUrl.origin.length)}`;
};
